import { FirebaseDocRefType } from 'firebase/index'
import { useEffect, useState } from 'react'

const useQueryDynamicLink = (storeRef: FirebaseDocRefType): string => {
  const [uri, setUri] = useState<string>('')
  useEffect(() => {
    if (!storeRef) return
    storeRef
      .collection('store_dynamiclinks')
      .orderBy('created_at', 'desc')
      .limit(1)
      .get()
      .then((snapshots) => {
        const snapshot = snapshots.docs[0]
        if (!snapshot) return
        const data = snapshot.data()
        if (!data || !('uri' in data)) return
        setUri(data.uri)
      })
  }, [storeRef])
  return uri
}

export default useQueryDynamicLink
